/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_gpa_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`On most 4.0 scales an A+ is capped at 4.0, the same as an A, because 4.0 is the maximum. Some schools award 4.3 — check your institution's policy.`)
};

const es_gpa_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`En la mayoría de las escalas de 4.0, una A+ tiene un tope de 4.0, igual que una A, porque 4.0 es el máximo. Algunas instituciones otorgan 4.3 — consulta la política de tu centro.`)
};

const de_gpa_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Auf den meisten 4,0-Skalen ist ein A+ auf 4,0 begrenzt, genau wie ein A, da 4,0 das Maximum ist. Manche Schulen vergeben 4,3 — prüfe die Regelung deiner Einrichtung.`)
};

const nl_gpa_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Op de meeste schalen van 4,0 wordt een A+ afgetopt op 4,0, net als een A, omdat 4,0 het maximum is. Sommige scholen kennen 4,3 toe — controleer het beleid van jouw instelling.`)
};

const fr_gpa_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sur la plupart des échelles de 4,0, un A+ est plafonné à 4,0, comme un A, car 4,0 est le maximum. Certains établissements attribuent 4,3 — vérifiez la politique de votre établissement.`)
};

const it_gpa_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nella maggior parte delle scale 4.0 una A+ è limitata a 4.0, come una A, perché 4.0 è il massimo. Alcune scuole assegnano 4.3 — controlla la politica del tuo istituto.`)
};

const pt_br2_gpa_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Na maioria das escalas de 4,0, o A+ é limitado a 4,0, igual ao A, porque 4,0 é o máximo. Algumas instituições atribuem 4,3 — confira a política da sua instituição.`)
};

const pt_gpa_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Na maioria das escalas de 4,0, um A+ está limitado a 4,0, tal como um A, porque 4,0 é o máximo. Algumas instituições atribuem 4,3 — confirme a política da sua instituição.`)
};

const ja_gpa_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ほとんどの4.0スケールではA+も4.0が上限となり、Aと同じ扱いです。4.0が最大値だからです。学校によっては4.3を採用している場合もあるため、所属機関の方針を確認してください。`)
};

const zh_gpa_faq_a4 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`在大多数 4.0 制下，A+ 与 A 一样被限定为 4.0，因为 4.0 是上限。部分学校会给予 4.3——请查阅你所在院校的具体政策。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const gpa_faq_a4 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.gpa_faq_a4(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("gpa_faq_a4", locale)
	if (locale === "en") return en_gpa_faq_a4(inputs)
	if (locale === "es") return es_gpa_faq_a4(inputs)
	if (locale === "de") return de_gpa_faq_a4(inputs)
	if (locale === "nl") return nl_gpa_faq_a4(inputs)
	if (locale === "fr") return fr_gpa_faq_a4(inputs)
	if (locale === "it") return it_gpa_faq_a4(inputs)
	if (locale === "pt-BR") return pt_br2_gpa_faq_a4(inputs)
	if (locale === "pt") return pt_gpa_faq_a4(inputs)
	if (locale === "ja") return ja_gpa_faq_a4(inputs)
	return zh_gpa_faq_a4(inputs)
};